import Layout from "../Layouts/Index";
import BoxHeader from "../components/BoxHeader";
import React, {useState} from "react";
import Accordion from "../components/Accordion";
import {faqsOptions} from "../Assets/StaticContents/FaqsContents";

const Faqs = () => {
    const [showPanel, setShowPanel] = useState(null)
    const text = "Below you'll find answers to the questions we get asked the most."
    const faqs_lists = faqsOptions.map((faqs, key) => {
        return (
            <Accordion
                label={faqs.question}
                isActive={key === showPanel}
                handleClick={() => setShowPanel(key === showPanel ? null : key)}
                key={key}
            >
                <div>
                    <div>
                        {faqs.answer}
                    </div>
                </div>
            </Accordion>
        )
    });

    return (
        <Layout>
            <div className="px-2 sm:px-4 md:px-10 lg:px-16 py-4">
                <BoxHeader text={text} title="Frequently Asked Questions" />
            </div>

            <div className="px-2 sm:px-4 md:px-12 lg:px-20 xl:px-32 py-4">
                <div className="w-full">
                    <div className="mx-auto">
                        <div className="grid grid-cols-1 my-4 lg:grid-cols-2">
                            <div className="my-auto">
                                <p className="font-normal text-md text-gray-700 inline-flex">
                                    <span>Show All</span>
                                    <span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.70956 11.71L11.2996 14.3C11.6896 14.69 12.3196 14.69 12.7096 14.3L15.2996 11.71C15.9296 11.08 15.4796 10 14.5896 10H9.40956C8.51956 10 8.07956 11.08 8.70956 11.71Z" fill="#333333"/></svg>
                                    </span>
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="mx-auto mb-16">
                    <dl className="mt-6">
                        {faqs_lists}
                    </dl>
                </div>
            </div>
        </Layout>
    )
}

export default Faqs;